import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

let key = 0

const Alerts = ({ alerts, setAlerts, updateAvailable }) => {

  const removeAlert = i =>
    setAlerts(a => {
      const ac = [...a]
      ac.splice(i,1)
      return ac
    })

  return (
    <Stack sx={{ width: '100%' }} spacing={1}>
      {updateAvailable && (
        <Alert 
          severity="info" 
          sx={{ borderRadius: 0 }}
          action={
            <Button color="inherit" size="small" onClick={() => window.location.reload()}>
              Refresh Now
            </Button>
          }
        >
          New version available. Refresh now to avoid errors and get the latest updates.
        </Alert>
      )}
      {alerts && !!alerts.length && alerts.slice(-3).map((alert, i) =>
        <Alert variant="outlined" key={key++} severity={alert.severity} onClose={() => removeAlert(i)}>{`${alert.timestamp?.toLocaleString()}: ${alert.message}`}</Alert>
      )}
    </Stack>
  )
}

export default Alerts